import { Injectable } from '@angular/core';
import { ConfigService } from '../../common/services/config.service';
import { HttpInterceptor } from '../../common/services/httpInterceptor.service';
import { SessionHandlerService } from '../../common/services/sessionHandler.service';
import { CommonConstants } from '../../common/utilities/commonConstants';
import { SharedService } from 'src/app/common/services/sharedService';




@Injectable()

export class CongratulationsService {
  constructor(
    private _httpInterceptor: HttpInterceptor,
    private _sessionHandlerService: SessionHandlerService,
    private sharedService: SharedService,

  ) { }
  public applicationId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
  public quoteId = (this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId));
  public getCallservice(endpoint, quoteItemId?, setRoute?) {
    let url = ConfigService.getInstance().getConfigObject().APIURL[endpoint];
    url = url.replace('{quoteId}', this.quoteId);
    url = url.replace('{applicationId}', this.applicationId);
    if (quoteItemId) {
      url = url.replace('{quoteItemId}', quoteItemId);
    }
    if (setRoute) {
      url = url + '?route=queue';
    }
    return this._httpInterceptor.Get(url);

  }
  public postCallservice(data, taskName?) {
    let url = ConfigService.getInstance().getConfigObject().APIURL.emiOPTPost;
    return this._httpInterceptor.Post(url, { action: taskName, payload: data });
  }
  public showSummary() {
    let controlName;
    const quoteId = (this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId));
    const applicationId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
    controlName = ConfigService.getInstance().getConfigObject().APIURL.getSummaryDetails;
    controlName = controlName.replace('{applicationId}', applicationId);
    controlName = controlName.replace('{quoteId}', quoteId);
    const url = controlName;
    return this._httpInterceptor.Get(url);
  }
  public PostPolicy(data) {
    let url = ConfigService.getInstance().getConfigObject().APIURL.getPolicy;
    url = url.replace('{applicationId}', data.urlData.applicationId);
    url = url.replace('{quoteId}', data.urlData.quoteId);
    return this._httpInterceptor.Post(url, data.payload);
  }
}
